import type { DepositType } from '@api';

export const getDreamhausHrefForDeposit = (
  deposit: DepositType
): string | null => {
  const artistId = deposit.artist.id;

  switch (deposit.module) {
    case 'TOURING': {
      const { tourId, subjectType } = deposit;
      if (!tourId) return null;

      if (subjectType === 'MAIN_ARTIST') {
        return `/projects/touring/${tourId}/contracting-deposit`;
      }
      if (subjectType === 'CO_HEADLINER') {
        return `/projects/touring/${tourId}/contracting-deposit/coheadliner/${artistId}`;
      }
      if (subjectType === 'SUPPORT_ACT') {
        return `/projects/touring/${tourId}/contracting-deposit/supportact/${artistId}`;
      }
      return null;
    }
    case 'TALENT_GRID': {
      if (!deposit.talentGridId) return null;
      return `/projects/festivals/talentgrid/${deposit.talentGridId}/contracting-deposit/${artistId}`;
    }
    case 'FESTIVAL': {
      if (!deposit.festivalId) return null;
      return `/projects/festivals/${deposit.festivalId}`;
    }
    default:
      return null;
  }
};
